import React, { useState, useEffect, useRef } from "react";
import uploadFile from "../../assets/UploadFile.png";
import { Form, Card, Button, Modal, Pagination } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import Header from "../Header/Header.jsx";
import { UserManager } from "oidc-client-ts";
import oidcConfig from "../../utils/Authconfig";
import PropTypes from "prop-types";
import Swal from "sweetalert2";
import "./home.css";
import TranslateFile from "../Translatefile/Translatefile.jsx";
import Previewfile from "../Previewfile/Previewfile.jsx";
import "@fortawesome/fontawesome-free/css/all.min.css";
import {
  deleteFiles,
  getAllFiles,
  getTranslatedFiles,
  retryTranslateFile,
} from "../../services/api";
import { STORAGE_KEY } from "../../utils/Constant";

function Home({ flag, setFlag }) {
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);
  const [selectedTranslatedFile, setSelectedTranslatedFile] = useState(null);
  const [userEmail, setUserEmail] = useState(null);
  const [userName, setUserName] = useState(null);
  const [showUploadContainer, setShowUploadContainer] = useState(true);
  const [showTranslateModal, setShowTranslateModal] = useState(false);
  const [showPreviewModal, setShowPreviewModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [translatedFileMap, setTranslatedFileMap] = useState({});
  const [dashboard, setDashboard] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");
  const [pageCount, setPageCount] = useState(0);
  const [allPages,setAllPages]=useState(0);
  const [shouldFetchFiles, setShouldFetchFiles] = useState(false);
  const [hoveredFileId, setHoveredFileId] = useState(null);

  const keycloak = new UserManager(oidcConfig);
  const filesPerPage = 15;
  const fileInputRef = useRef(null);

  useEffect(() => {
    keycloak.getUser().then((user) => {
      if (user) {
        setUserEmail(user.profile.email);
        setUserName(user.profile.name);
      }
    });
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      fetchFiles();
    }, 30000);

    return () => clearInterval(interval);
  }, []);

  const fetchFiles = async () => {
    try {
      const data = localStorage.getItem(STORAGE_KEY.AUTH_DATA);
      const parsedData = JSON.parse(data);

      console.log("Parsed data:", parsedData);
      const AT = parsedData.accessToken;
      const RT = parsedData.refreshToken;
      const response = await getAllFiles(AT, RT);
      const pagecount = response.page_count.used_pages;
      const allpages =response.page_count.total_pages;
      console.log("Page Count:---------------", pagecount,allPages);
      setPageCount(pagecount);
      setAllPages(allpages);
      if (
        response &&
        response.status_code === 200 &&
        Array.isArray(response.user_history)
      ) {
        setUploadedFiles(response.user_history);
        setDashboard(response.user_history);
        if (response.user_history.length > 0) {
          setShowUploadContainer(false);
        }
      } else {
        throw new Error("Invalid response format");
      }
    } catch (error) {
      console.error("Error fetching files:", error);
      setErrorMessage("Failed to fetch files. Please try again.");
      setUploadedFiles([]);
    }
  };

  async function getFileType(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = function () {
        const arr = new Uint8Array(reader.result).subarray(0, 4);
        let header = "";
        for (let i = 0; i < arr.length; i++) {
          header += arr[i].toString(16);
        }
        console.log(header, "header");
        switch (header) {
          case "25504446":
            resolve("application/pdf");
            break;
          case "89504e47":
            resolve("image/png");
            break;
          case "89504e47":
            resolve("image/PNG");
            break;
          case "ffd8ffe0":
            resolve("image/jpeg"); // General case for JPEG images
            break;
          case "504b34":
            resolve(
              "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
            );
            break;
          default:
            resolve("application/octet-stream");
            break;
        }
      };
      reader.onerror = function () {
        reject("Error reading file");
      };
      reader.readAsArrayBuffer(file);
    });
  }

 const handleAction = async (fileId, actionType) => {
    const file = uploadedFiles.find((f) => f.id === fileId);
    if (!file) {
      console.error("File not found for ID:", fileId);
      return;
    }
    setSelectedFile(file);
    if (actionType === "view") {
      try {
        const translatedFiles = await getTranslatedFiles(file.id);
        console.log("Translated Files API Response:", translatedFiles);

        const fileData = translatedFiles.original.data;
        const fileType = await getFileType(new Blob([fileData]));

        if (!fileData) {
          console.error("File data is missing!");
          return;
        }

        // const blob = new Blob([new Uint8Array(fileData)], { type: fileType });
        const blob = new Blob([fileData], { type: fileType });

        const blobUrl = URL.createObjectURL(blob);

        const fileWithPreview = {
          ...file,
          file_name: file.file_name, // Set correct name
          preview: blobUrl,
          type: fileType,
        };

        console.log("Updated File for Preview:", fileWithPreview);

        setSelectedFile(fileWithPreview);

        const translatedData = translatedFiles.translated.data;
        const translatedType = await getFileType(new Blob([translatedData]));
        const translatedBlob = new Blob([translatedData], {
          type: translatedType,
        });
        console.log("translatedblob", translatedBlob);
        const translatedBlobUrl = URL.createObjectURL(translatedBlob);
        console.log("translatedBlob:", translatedBlob);
        const translatedFileWithPreview = {
          ...file,
          file_name: file.file_name, // Set correct name
          preview: translatedBlobUrl,
          type: translatedType,
          data: translatedData, // <--- Add the raw data here
          headers: translatedFiles.translated.headers, // <--- Add the headers here
        };
        setTranslatedFileMap(translatedFileWithPreview);
        setShowPreviewModal(true);
      } catch (error) {
        console.error("Error fetching translated files:", error);
      }
    } else if (actionType === "download") {
      const translatedFiles = await getTranslatedFiles(file.id);
      const translatedBlob = new Blob([translatedFiles.translated.data], {
        type: await getFileType(new Blob([translatedFiles.translated.data])),
      });
      // Pass the headers along with the blob and file object
      handleDownload(translatedBlob, file, translatedFiles.translated.headers);
    } else if (actionType === "delete") {
      Swal.fire({
        title: `Delete "${file.file_name}"?`,
        text: "Are you sure you want to delete this file?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: "Yes, delete it!",
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            await deleteFiles(file.id);
            const updatedFiles = uploadedFiles.filter((f) => f.id !== file.id);
            setUploadedFiles(updatedFiles);
            fetchFiles();
          } catch (error) {
            console.error("Error deleting file:", error);
            Swal.fire({
              title: "Error!",
              text: "Failed to delete the file. Please try again.",
              icon: "error",
              customClass: { popup: "error-popup" },
            });
          }
        }
      });
    }
  };

  const handleDownload = (translatedBlob, file, translatedHeaders) => {
    if (!translatedBlob) {
      console.error("Translated blob is not valid!");
      return;
    }

    let filename = file.file_name; // Default to existing filename

    // Try to get filename from content-disposition header if available
    if (translatedHeaders && translatedHeaders["content-disposition"]) {
      const contentDisposition = translatedHeaders["content-disposition"];
      const filenameMatch = contentDisposition.match(/filename="([^"]+)"/);
      if (filenameMatch && filenameMatch[1]) {
        filename = filenameMatch[1];
      }
    }

    const link = document.createElement("a");
    link.href = URL.createObjectURL(translatedBlob);
    link.download = filename; // Use the extracted filename
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(link.href); // Free memory after download
  };

  
  const handleUploadClick = () => {
    if (totalPages >= 500) {
      setErrorMessage("Cannot add more files, page limit reached (500).");
      setShowErrorModal(true);
      return;
    }
  };

  const handleFileUpload = (event) => {
    console.log("handleFileUpload called");
    const file = event.target.files[0];
    if (!file) {
      console.log("No file selected");
      return;
    }

    console.log("Uploaded file:", file);
    console.log("File type:", file.type);
    console.log("File size:", file.size);

    const validTypes = [
      "image/png",
      "image/jpeg",
      "image/jpg",
      "application/pdf",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    ];

    if (!validTypes.includes(file.type)) {
      console.log("Invalid file type");
      setShowErrorModal(true);
      setErrorMessage("Please upload a PNG, JPG, JPEG, PDF, or DOCX file.");
      return;
    }

    if (
      file.type ===
        ("application/pdf",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document") &&
      file.size > 25 * 1024 * 1024
    ) {
      setShowErrorModal(true);
      setErrorMessage("File size should not exceed 25MB.");
      return;
    }

    if (
      file.type === ("image/png", "image/jpeg", "image/jpg") &&
      file.size > 20 * 1024 * 1024
    ) {
      setShowErrorModal(true);
      setErrorMessage("File size should not exceed 20MB.");
      return;
    }

    console.log("File accepted");
    setSelectedTranslatedFile(file);
    setErrorMessage("");
  };

  const handleSearchChange = (event) => {
    const query = event.target.value;
    setSearchQuery(query);
    console.log(query);
  };

  const filteredFiles = uploadedFiles.filter((file) =>
    file.name?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const reversedFilteredFiles = [...filteredFiles].reverse();
  console.log("reversedFilteredFiles", uploadedFiles.length);
  const indexOfLastFile = currentPage * filesPerPage;
  const indexOfFirstFile = indexOfLastFile - filesPerPage;
  console.log("indexOfLastFile", indexOfFirstFile);
  const currentFiles = uploadedFiles.slice(indexOfFirstFile, indexOfLastFile);
  console.log("currentFiles", currentFiles);
  const totalPages = Math.ceil(uploadedFiles.length / filesPerPage);
  // console.log("totalPages", totalPages);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  useEffect(() => {
    let data = uploadedFiles.filter((each) => {
      return each.file_name?.toUpperCase().includes(searchQuery?.toUpperCase());
    });
    setDashboard(data);
  }, [searchQuery]);

  useEffect(() => {
    let offset = (currentPage - 1) * filesPerPage;
    let limit = currentPage * filesPerPage;
    let data = uploadedFiles.slice(offset, limit);
    setDashboard(data);
  }, [currentPage, uploadedFiles]);

  useEffect(() => {
    fetchFiles();
  }, [shouldFetchFiles === true]);

  const handleCloseErrorModal = () => setShowErrorModal(false);
  const handleRetryTranslation = async (fileId) => {
    try {
      console.log("Clicked to retry translation for file ID:", fileId);
      const data = localStorage.getItem(STORAGE_KEY.AUTH_DATA);
      const parsedData = JSON.parse(data);
      
      const AT = parsedData.accessToken;
      const RT = parsedData.refreshToken;
      const response = await retryTranslateFile(fileId,AT, RT);
      if(response && response.status_code === 200) {
      console.log("Translation retry successful:", response);
      fetchFiles();
    }
  else if(response && response.status_code === 404) {
    console.log("File not found for retry translation:", response);
      Swal.fire("File not found for retry translation.");
      // setShowErrorModal(true);
    }
}
     catch (error) {
      // console.error("Error retrying translation:", error);
      Swal.fire("Failed to retry translation.Please try again.");
      // setShowErrorModal(true);
    }
  };

  return (
    <div className="App" style={{ height: "auto" }}>
      <Header
        pageCount={pageCount}
        allPages={allPages}

      />
      <div
        className="search-upload-container"
      >
        <Form
          className="search-form"
          style={{ width: "15%", marginRight: "10px" }}
        >
          <Form.Control
            type="text"
            placeholder="Search"
            className="search-input"
            value={searchQuery}
            onChange={handleSearchChange}
            style={{ fontSize: "0.9rem" }}
          />
        </Form>
        <label
          className="upload-button"
          onClick={handleUploadClick}
          style={{ fontSize: "0.9rem" }}
        >
          Upload File
          <input
            id="file-upload"
            type="file"
            ref={fileInputRef}
            style={{ display: "none" }}
            data-testid="upload-input"
            onChange={handleFileUpload}
          />
        </label>
      </div>
      {selectedTranslatedFile && (
        <TranslateFile
          file={selectedTranslatedFile}
          setShouldFetchFiles={setShouldFetchFiles}
          shouldFetchFiles={shouldFetchFiles}
          setSelectedTranslatedFile={setSelectedTranslatedFile}
        />
      )}
      {dashboard.length === 0 ? (
        <div style={{ margin: "10px 10px" }}>
          <Card className="card-custom">
            <div className="image-uploaded">
              <img
                src={uploadFile}
                alt="Uploaded file icon"
                className="image-uploaded"
              />
            </div>
            <h5 className="mb-2">No files uploaded yet</h5>
            <p className="text-muted mb-3">
              We'll display all your translated files here.
            </p>
            <div className="mb-3">
              <label
                className="upload-button"
                onClick={handleUploadClick}
                style={{ fontSize: "0.9rem" }}
              >
                Upload File
                <input
                  id="file-upload"
                  type="file"
                  ref={fileInputRef}
                  style={{ display: "none" }}
                  onChange={handleFileUpload}
                />
              </label>
            </div>
          </Card>
        </div>
      ) : (
        <>
          <div className="grid-container-wrapper">
            <div className="grid-header">
              <div className="grid-header-item">S.No</div>
              <div className="grid-header-item">File Name</div>
              <div className="grid-header-item">Uploaded time</div>
              <div className="grid-header-item">
                Status{" "}
                <i
                  className="fa-solid fa-filter"
                  style={{
                    marginLeft: "5px",
                    color: "#554a4a",
                    cursor: "pointer",
                  }}
                  onClick={() => console.log("Filter icon clicked")}
                />
              </div>
              <div className="grid-header-item">Actions</div>
            </div>

            <div className="grid-body">
              {dashboard.map((file, index) => (
                <div key={file.id} className="grid-row">
                  <div className="grid-item">
                    {index + 1 + (currentPage - 1) * filesPerPage}
                  </div>
                  <div className="grid-item">{file.file_name}</div>
                  <div className="grid-item">{file.upload_time}</div>

                  <div className="grid-item status-display-cell">
                    {file.status === "Error Translating" ? (
                      <>
                        <span className="error-status-text-wrapper">
                          Error Translating
                          <div className="status-tooltip">
                            CronJob is not working
                          </div>
                        </span>
                        <span className="status-separator">|</span>
                        <i
                          className="fa-solid fa-rotate retry-icon"
                          onClick={() => handleRetryTranslation(file.id)}
                        ></i>
                      </>
                    ) : (
                      file.status
                    )}
                  </div>

                  <div className="grid-item action-links">
                    <Button
                      variant="link"
                      onClick={() => handleAction(file.id, "view")}
                    >
                      View
                    </Button>
                    <span className="separator">|</span>
                    <Button
                      variant="link"
                      onClick={() => handleAction(file.id, "download")}
                      disabled={
                        file.status === "In Progress" ||
                        file.status === "Error Translating"
                      }
                    >
                      Download
                    </Button>
                    <span className="separator">|</span>
                    <Button
                      variant="link"
                      onClick={() => handleAction(file.id, "delete")}
                    >
                      Delete
                    </Button>
                  </div>
                </div>
              ))}
            </div>

            {/* for......................Pagination */}
            {totalPages > 1 && (
              <Pagination className="justify-content-end pagination-custom">
                <Pagination.Prev
                  onClick={() => setCurrentPage(currentPage - 1)}
                  disabled={currentPage === 1}
                >
                  &lt;
                </Pagination.Prev>
                {Array.from({ length: totalPages }).map((_, index) => (
                  <Pagination.Item
                    key={index + 1}
                    active={index + 1 === currentPage}
                    onClick={() => paginate(index + 1)}
                  >
                    {index + 1}
                  </Pagination.Item>
                ))}
                <Pagination.Next
                  onClick={() => setCurrentPage(currentPage + 1)}
                  disabled={currentPage === totalPages}
                >
                  &gt;
                </Pagination.Next>
              </Pagination>
            )}
          </div>
        </>
      )}

      {/* for................................... Preview Modal */}
      {selectedFile && (
        <Modal
          show={showPreviewModal}
          onHide={() => setShowPreviewModal(false)}
          size="xl"
          centered
          className="preview-modal-backdrop"
        >
          <Modal.Body>
            <Previewfile
              originalFile={selectedFile}
              translatedFile={translatedFileMap}
              onClose={() => setShowPreviewModal(false)}
            />
          </Modal.Body>
        </Modal>
      )}

      <Modal
        show={showErrorModal}
        onHide={handleCloseErrorModal}
        centered
        className="small-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>Error</Modal.Title>
        </Modal.Header>
        <Modal.Body className="errormessage">{errorMessage}</Modal.Body>
        <Modal.Footer>
          <Button
            className="error-close"
            variant="secondary"
            onClick={handleCloseErrorModal}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default Home;